import { customEvent } from "goi_common";
import { useParlorInquiryModal } from "@/hooks/useParlorInquiryModal";

/**
 * E5 「임종하셨다면 지금 바로 전화하기」. #358 임종 배너(승자 B)와 같은 이벤트 · 같은 동작이다.
 * 문의 유형 모달을 띄워 조문 문의는 장례식장 직통으로 거르고, 임종 문의는 고이 24시간 전화로 보낸다.
 */
export const useE5UrgentCall = () => {
  const { openParlorInquiryModal } = useParlorInquiryModal("urgent_bnr");
  return () => {
    customEvent({
      newGtm: { path: "parlor_match_request", trigger_and_target: "urgent_bnr_call" },
    });
    customEvent({
      newGtm: {
        action: "urgent_call_click",
        properties: { page: "parlor_match_request", source: "banner" },
      },
    });
    void openParlorInquiryModal();
  };
};
